



































































































































































































































































































































































































































































import { localISODate, parseLocalDate } from "@/utils/localDate";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import SvcPermintaan from "@/services/PermintaanKomponenDarah";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import IdentitasPasienRingkas from "@/components/pemeriksaan/order-darah/IdentitasPasienRingkas.vue";
import CetakLabelKantongDialog from "@/components/pemeriksaan/order-darah/CetakLabelKantongDialog.vue";
import { STATUS_WARNA } from "@/types/order_bank_darah";
import { alasanTidakBisaHapusPermintaan } from "@/utils/hapusPermintaanDarah";
import {
  KELAS_OPTIONS,
  prefillBangsalKelas
} from "@/utils/prefillBangsalKelas";

@Component({
  components: { UnitRuangPicker, VCDateTimePicker, IdentitasPasienRingkas, CetakLabelKantongDialog },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class PermintaanKomponenDarahPage extends Vue {
  @Prop() readonly register;
  @Prop() readonly rm;
  @Prop({ type: Boolean, default: true })
  readonly showMonitoringShortcut!: boolean;
  isReadOnly!: () => boolean;

  list: any[] = [];
  loading = false;
  saving = false;
  simpanTtd = false;

  formDialog = false;
  form: any = this.emptyForm();

  signDialog = false;
  signPassword = "";
  showPassword = false;
  signing = false;

  dialogLabel = false;
  labelItem: any = null;

  headers = [
    { text: "Tanggal", value: "tanggal_permintaan" },
    { text: "Nomor", value: "nomor" },
    { text: "Komponen", value: "komponen", sortable: false },
    { text: "Jenis Order", value: "jenis_order", sortable: false },
    { text: "Status", value: "status" },
    { text: "Aksi", value: "aksi", sortable: false, align: "end" }
  ];

  kelasOptions = KELAS_OPTIONS;
  bagianOptions = [
    { text: "Anak", value: "anak" },
    { text: "Bedah", value: "bedah" },
    { text: "Kebidanan/Kandungan", value: "kebidanan" },
    { text: "Penyakit Dalam", value: "penyakit_dalam" },
    { text: "Lain-lain", value: "lain" }
  ];
  rhesusOptions = [
    { text: "Positif", value: "positif" },
    { text: "Negatif", value: "negatif" }
  ];
  macamOptions = [
    { text: "Whole Blood (WB)", value: "wb" },
    { text: "Packed Red Cell (PRC)", value: "prc" },
    { text: "Platelet Concentrate (Trombosit)", value: "tc" },
    { text: "Platelet Rich Plasma (PRP)", value: "prp" },
    { text: "Fresh Plasma (FP)", value: "fp" },
    { text: "Fresh Frozen Plasma (FFP)", value: "ffp" },
    { text: "Washed Red Cell (WRC)", value: "wrc" },
    { text: "Cryoprecipitate (AHF)", value: "cryo" },
    { text: "Buffy Coat / Leucocyta", value: "buffy_coat" },
    { text: "Lain-lain", value: "lainnya" }
  ];

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  warnaStatus(status: string): string {
    return STATUS_WARNA[status] || "blue-grey";
  }

  get tglTransfusiTerakhir(): Date | null {
    return parseLocalDate(this.form.transfusi_terakhir_tgl);
  }

  set tglTransfusiTerakhir(val: Date | null) {
    this.form.transfusi_terakhir_tgl = val ? localISODate(val) : null;
  }

  get tglPermintaan(): Date | null {
    return parseLocalDate(this.form.tanggal_permintaan);
  }

  set tglPermintaan(val: Date | null) {
    this.form.tanggal_permintaan = val ? localISODate(val) : null;
  }

  get tglDiperlukan(): Date | null {
    return parseLocalDate(this.form.tanggal_diperlukan);
  }

  set tglDiperlukan(val: Date | null) {
    this.form.tanggal_diperlukan = val ? localISODate(val) : null;
  }

  get lockedForm(): boolean {
    return !!this.form.is_locked || this.readOnly;
  }

  get isDokter(): boolean {
    return userModule.user.profesi === "Dokter";
  }

  get listDokter() {
    return storeDokter.list;
  }

  mounted() {
    this.load();
    if (!storeDokter.list.length) {
      storeDokter.act_dokter_all();
    }
  }

  emptyForm() {
    return {
      id: null,
      is_locked: false,
      dokter_peminta_user_id: null,
      dokter_peminta_nama: "",
      jenis_order: "langsung",
      bangsal: "",
      kelas: null,
      bagian: null,
      bagian_lain: "",
      hb: null,
      at: null,
      transfusi_sebelumnya: false,
      transfusi_terakhir_tgl: null,
      transfusi_jumlah_kolf: null,
      diagnosa: "",
      tanggal_permintaan: localISODate(),
      tanggal_diperlukan: null,
      hal_lain: "",
      items: []
    };
  }

  async load() {
    this.loading = true;
    try {
      const resp = await SvcPermintaan.getByRegister(this.register);
      this.list = resp && resp.data ? resp.data : [];
    } finally {
      this.loading = false;
    }
  }

  get prefillDariRegister() {
    return prefillBangsalKelas(RegisterKunjungan.register, this.register);
  }

  openForm(item: any = null) {
    if (item) {
      this.form = {
        ...item,
        jenis_order: item.jenis_order || "langsung",
        dokter_peminta_user_id:
          item.dokter_peminta_user_id || this.idDokterDariNama(item.dokter_peminta_nama),
        items: (item.items || []).map(i => ({ ...i }))
      };
    } else {
      this.form = { ...this.emptyForm(), ...this.prefillDariRegister, ...this.prefillDokter() };
    }
    this.formDialog = true;
  }

  prefillDokter() {
    const user: any = userModule.user;
    if (!user || !this.isDokter) return {};
    const dariList = this.listDokter.find((d: any) => String(d.id) === String(user.id));
    return {
      dokter_peminta_user_id: user.id,
      dokter_peminta_nama: dariList ? dariList.nama : user.nama || ""
    };
  }

  idDokterDariNama(nama: string | null): number | null {
    if (!nama) return null;
    const cocok = this.listDokter.find((d: any) => d.nama === nama);
    return cocok ? cocok.id : null;
  }

  pilihDokter(id: number | null) {
    const dokter = this.listDokter.find((d: any) => String(d.id) === String(id));
    this.form.dokter_peminta_nama = dokter ? dokter.nama : "";
  }

  alasanTidakBisaHapus(item: any): string {
    const slots = item.is_locked
      ? [{ ditandatangani: true, penandaTanganId: item.dokter_user_id }]
      : [];
    return alasanTidakBisaHapusPermintaan(
      item.status,
      item.creator_user_id,
      slots,
      userModule.user ? userModule.user.id : null
    );
  }

  @Watch("form.transfusi_sebelumnya")
  onTransfusiChange(val: boolean) {
    if (!val) {
      this.form.transfusi_terakhir_tgl = null;
      this.form.transfusi_jumlah_kolf = null;
    }
  }

  @Watch("form.bagian")
  onBagianChange(val: string) {
    if (val !== "lain") this.form.bagian_lain = "";
  }

  addRow() {
    this.form.items.push({
      macam: "prc",
      macam_lain: null,
      gol_darah: null,
      rhesus: null,
      unit_kolf: null,
      volume_cc: null,
      catatan: null
    });
  }

  cekIsianWajib(): string | null {
    const wajib: Array<[string, unknown]> = [
      ["Bangsal / Ruang", this.form.bangsal],
      ["Kelas", this.form.kelas],
      ["Dirawat di Bagian", this.form.bagian],
      ["Diagnosa", this.form.diagnosa],
      ["Hb", this.form.hb],
      ["Tanggal Permintaan", this.form.tanggal_permintaan],
      ["Tanggal Diperlukan", this.form.tanggal_diperlukan]
    ];

    const kurang = wajib
      .filter(([, nilai]) => nilai === null || nilai === undefined || nilai === "")
      .map(([label]) => label);

    if (this.form.bagian === "lain" && !this.form.bagian_lain) {
      kurang.push("Sebutkan bagian");
    }

    return kurang.length ? "Lengkapi dulu: " + kurang.join(", ") + "." : null;
  }

  async save(tandatangani = false) {
    if (this.saving) return;

    const kurang = this.cekIsianWajib();
    if (kurang) {
      appModule.sendErrorAlert(kurang);
      return;
    }

    this.saving = true;
    this.simpanTtd = tandatangani;
    try {
      const payload = {
        ...this.form,
        register_id: this.register,
        pasien_rm: this.rm,
        unit_id: userModule.user.unit_id
      };
      let resp;
      if (this.form.id) {
        resp = await SvcPermintaan.update(this.form.id, payload);
      } else {
        resp = await SvcPermintaan.create(payload);
      }
      this.form = { ...resp.data, items: (resp.data.items || []).map(i => ({ ...i })) };
      appModule.sendSuccessNotice("Permintaan komponen darah tersimpan");
      this.formDialog = false;
      this.load();
      if (tandatangani && this.form.id) {
        this.openSign();
      }
    } finally {
      this.saving = false;
      this.simpanTtd = false;
    }
  }

  async destroy(item: any) {
    if (!confirm("Hapus permintaan ini?")) return;
    await SvcPermintaan.destroy(item.id);
    this.load();
  }

  openSign() {
    this.signPassword = "";
    this.showPassword = false;
    this.signDialog = true;
  }

  openSignItem(item: any) {
    this.form = { ...item, items: (item.items || []).map(i => ({ ...i })) };
    this.openSign();
  }

  async doSign() {
    if (this.signing) return;
    this.signing = true;
    try {
      await SvcPermintaan.sign(this.form.id, { password: this.signPassword });
      appModule.sendSuccessNotice("Permintaan komponen darah ditandatangani");
      this.signDialog = false;
      const resp = await SvcPermintaan.find(this.form.id);
      this.form = { ...resp.data, items: (resp.data.items || []).map(i => ({ ...i })) };
      this.load();
    } finally {
      this.signing = false;
    }
  }

  printPdf(item: any) {
    SvcPermintaan.printPdf(item.id);
  }

  bukaLabel(item: any) {
    this.labelItem = item;
    this.dialogLabel = true;
  }

  cetakLabel(jumlah: number) {
    if (this.labelItem) SvcPermintaan.printLabel(this.labelItem.id, jumlah);
  }

  toMonitoring(item: any) {
    const first = item.items && item.items[0] ? item.items[0] : null;
    const prefill = {
      permintaan_komponen_darah_id: item.id,
      golongan_darah_pasien: first ? first.gol_darah : null,
      rhesus_pasien: first ? first.rhesus : null
    };
    sessionStorage.setItem(
      "prefill_monitoring_transfusi",
      JSON.stringify(prefill)
    );
    appModule.sendSuccessNotice(
      "Data permintaan disiapkan. Buka tab Monitoring Transfusi untuk mencatat transfusi."
    );
  }
}
